<template>
  <router-view class="recruitment-root page-max-width footer-max-width" />
</template>

<script>
  import { NotificationsManager } from "@core/managers/notifications.manager";
  import {
    ACTION_RECRUITMENTS_SET_SELECTED,
    ACTION_RECRUITMENT_CANDIDATES_GET_APPLIED,
    ACTION_RECRUITMENT_CANDIDATES_GET_CONTACTED,
    ACTION_RECRUITMENT_CANDIDATES_GET_RECRUITED,
    ACTION_RECRUITMENT_CANDIDATES_GET_IGNORED,
    ACTION_RECRUITMENT_GET,
  } from "@etab/stores/types";
  import { ETAB_ROUTES } from "@etab/config";
  import { useRecruitmentStore } from "@etab/stores/recruitment";
  import { useRecruitmentsStore } from "@etab/stores/recruitments";
  import { useRecruitmentCandidatesStore } from "@etab/stores/recruitment-candidates";

  /**
   * This component is here to manage the recruitment details pages by catching the events
   */
  export default {
    async beforeRouteUpdate(to, from, next) {
      const currentDemandId = from.params.demandId;
      const nextDemandId = to.params.demandId;
      const demandType = to.params.demandType;
      const shouldRefresh = currentDemandId.toString() !== nextDemandId.toString();
      const recruitmentStore = useRecruitmentStore();
      const recruitmentsStore = useRecruitmentsStore();
      const recruitmentCandidatesStore = useRecruitmentCandidatesStore();

      if (shouldRefresh) {
        try {
          this.$_startGlobalLoading();
          const demandId = nextDemandId;
          const promises = [
            recruitmentStore[ACTION_RECRUITMENT_GET]({ demandId, demandType }),
            recruitmentsStore[ACTION_RECRUITMENTS_SET_SELECTED](demandId),
          ];
          switch (to.name) {
            case ETAB_ROUTES.dashboard.recruitment.permanent.detail.applied.name:
              promises.push(
                recruitmentCandidatesStore[ACTION_RECRUITMENT_CANDIDATES_GET_APPLIED]({
                  demandId,
                  type: demandType,
                }),
              );
              break;
            case ETAB_ROUTES.dashboard.recruitment.permanent.detail.contacted.name:
              promises.push(
                recruitmentCandidatesStore[ACTION_RECRUITMENT_CANDIDATES_GET_CONTACTED]({
                  demandId,
                  type: demandType,
                }),
              );
              break;
            case ETAB_ROUTES.dashboard.recruitment.permanent.detail.recruited.name:
              promises.push(
                recruitmentCandidatesStore[ACTION_RECRUITMENT_CANDIDATES_GET_CONTACTED]({
                  demandId,
                  type: demandType,
                }),
              );
              promises.push(
                recruitmentCandidatesStore[ACTION_RECRUITMENT_CANDIDATES_GET_RECRUITED]({
                  demandId,
                  type: demandType,
                }),
              );
              break;
            case ETAB_ROUTES.dashboard.recruitment.permanent.detail.ignored.name:
              promises.push(
                recruitmentCandidatesStore[ACTION_RECRUITMENT_CANDIDATES_GET_IGNORED]({
                  demandId,
                  type: demandType,
                }),
              );
              break;
            default:
              break;
          }
          await Promise.all(promises);
          next();
        } catch (error) {
          NotificationsManager.error();
          throw error;
        } finally {
          this.$_stopGlobalLoading();
        }
      } else {
        next();
      }
    },
  };
</script>
